/**
 *  结构有点小复杂
 */

export default {
  path: '',
  meta: {
    title: '公共模块',
    ignoreBreadCrumb: true
  },
  name: 'public',
  component: () => import('@/components/parent-view'),
  children: [
    {
      path: 'system',
      meta: {
        title: '系统管理'
      },
      name: 'system',
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'function',
          name: 'system-function',
          meta: {
            title: '功能管理'
          },
          component: () => import('@/view/system/function')
        },
        {
          path: 'function/new',
          name: 'SystemMenuManage',
          meta: {
            title: '新功能管理'
          },
          component: () => import('@/view/system/function/new_index')
        },
        {
          path: 'role',
          name: 'system-role',
          meta: {
            title: '角色管理'
          },
          component: () => import('@/view/system/role')
        },
        {
          path: 'role/authority',
          name: 'system-authority',
          meta: {
            title: '角色权限设置',
            hideInTabBar: true
          },
          component: () => import('@/view/system/role/authority.vue')
        },
        {
          path: 'log',
          name: 'system-log',
          meta: {
            title: '系统日志'
          },
          component: () => import('@/view/system/log/index')
        },
        {
          path: 'user',
          name: 'system-user',
          meta: {
            title: '用户管理'
          },
          component: () => import('@/view/system/user')
        },
        {
          path: 'set',
          name: 'system-set',
          meta: {
            title: '系统设置'
          },
          component: () => import('@/view/system/set')
        },
        {
          path: 'category',
          name: 'cache-system-manage-category',
          meta: {
            title: '平台分类'
          },
          component: () => import('@/view/system/category')
        },
        {
          path: 'category',
          meta: {
            title: '平台分类'
          },
          component: () => import('@/components/parent-view'),
          children: [
            {
              path: 'edit',
              name: 'system-category-edit',
              meta: {
                hideInTabBar: true,
                title: '新增分类'
              },
              component: () => import('@/view/system/category/add')
            }
          ]
        },
        {
          path: 'organization',
          name: 'system-organization',
          meta: {
            title: '组织机构'
          },
          component: () => import('@/view/system/organization'),
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/system.js